unit View.Data_Base_Logs.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls, UUtils,
  UHelperServer;

type
  TFViewData_Base_LogsEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbstatus: TLabel;
    edstatus: TDBEdit;
    lbtransacao_inicial: TLabel;
    edtransacao_inicial: TDBEdit;
    lbtransacao_final: TLabel;
    edtransacao_final: TDBEdit;
    lbdata_coleta_log: TLabel;
    eddata_coleta_log: TDBEdit;
    lbsweep_executado: TLabel;
    lbtempo_gasto_sweep: TLabel;
    edtempo_gasto_sweep: TDBEdit;
    lbdescricao: TLabel;
    eddescricao: TDBEdit;
    lblog_gfix: TLabel;
    edlog_gfix: TDBEdit;
    lblog_sweep: TLabel;
    edlog_sweep: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    XDataClientData_Base_LogsGet: TXDataWebClient;
    Data_Base_LogsDataset: TXDataWebDataSet;
    Data_Base_LogsDatasetid: TIntegerField;
    Data_Base_LogsDatasetaliado_id: TIntegerField;
    Data_Base_LogsDatasetdata_base_id: TIntegerField;
    Data_Base_LogsDatasetstatus: TStringField;
    Data_Base_LogsDatasettransacao_inicial: TStringField;
    Data_Base_LogsDatasettransacao_final: TStringField;
    Data_Base_LogsDatasetdata_coleta_log: TDateTimeField;
    Data_Base_LogsDatasetdata_coleta_gfix: TDateTimeField;
    Data_Base_LogsDatasetsweep_executado: TBooleanField;
    Data_Base_LogsDatasettempo_gasto_sweep: TStringField;
    Data_Base_LogsDatasetdescricao: TStringField;
    Data_Base_LogsDatasetlog_gfix: TStringField;
    Data_Base_LogsDatasetlog_sweep: TStringField;
    Data_Base_LogsDatasetcodigo_interno: TIntegerField;
    Data_Base_LogsDatasetinclusao: TDateTimeField;
    Data_Base_LogsDatasetalteracao: TDateTimeField;
    Data_Base_LogsDatasetdb: TXDataWebEntityField;
    lbaliado: TLabel;
    edaliado: TDBEdit;
    lbcnpj: TLabel;
    edcnpj: TDBEdit;
    Data_Base_LogsDatasetdbaliadoNome_Fantasia: TStringField;
    Data_Base_LogsDatasetdbaliadoCNPJ: TStringField;
    Data_Base_LogsDatasetdbpath: TStringField;
    Data_Base_LogsDatasetdiferenca_transacao: TLargeintField;
    lbdb_path: TLabel;
    eddb_path: TDBEdit;
    lbdiferenca_transacao: TLabel;
    eddiferenca_transacao: TDBEdit;
    cbxsweep_executado: TDBCheckBox;
    procedure btCancelClick(Sender: TObject);
    procedure XDataClientData_Base_LogsGetLoad(Response: TXDataClientResponse);
    procedure Data_Base_LogsDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure Data_Base_LogsDatasetdbaliadoCNPJGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure Data_Base_LogsDatasetstatusGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure Data_Base_LogsDatasettransacao_inicialGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure Data_Base_LogsDatasettransacao_finalGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure Data_Base_LogsDatasetdiferenca_transacaoGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure Data_Base_LogsDatasetdescricaoGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure Data_Base_LogsDatasetlog_gfixGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure Data_Base_LogsDatasetlog_sweepGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewData_Base_LogsEdit: TFViewData_Base_LogsEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewData_Base_LogsEdit }

class function TFViewData_Base_LogsEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewData_Base_LogsEdit.InsertEntity;
begin
  Data_Base_LogsDataset.Close;
  Data_Base_LogsDataset.SetJsonData('{}');
  Data_Base_LogsDataset.Open;
  Data_Base_LogsDataset.Insert;
end;

class function TFViewData_Base_LogsEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewData_Base_LogsEdit(AForm).FInserting := AInserting;
    TFViewData_Base_LogsEdit(AForm).FId := AId;
    TFViewData_Base_LogsEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewData_Base_LogsEdit(AForm).InsertEntity
    else
      TFViewData_Base_LogsEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewData_Base_LogsEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewData_Base_LogsEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Data_Base_LogsDataset.Connection.Model.DefaultSchema.FindEntityType(
      Data_Base_LogsDataset.EntitySetName
    )
  );

  QueryString := QueryString + ', db/aliado';

  XDataClientData_Base_LogsGet.Get(Data_Base_LogsDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewData_Base_LogsEdit.XDataClientData_Base_LogsGetLoad(Response: TXDataClientResponse);
begin
  Data_Base_LogsDataset.Close;
  Data_Base_LogsDataset.SetJsonData(Response.Result);
  Data_Base_LogsDataset.Open;

  Data_Base_LogsDataset.Edit;
end;

procedure TFViewData_Base_LogsEdit.Data_Base_LogsDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin

      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewData_Base_LogsEdit.Data_Base_LogsDatasetdbaliadoCNPJGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCnpj_Cpf(Sender.AsString);
end;

procedure TFViewData_Base_LogsEdit.Data_Base_LogsDatasetdescricaoGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := Sender.AsString.ToUpper;
end;

procedure TFViewData_Base_LogsEdit.Data_Base_LogsDatasetdiferenca_transacaoGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  if not Sender.AsString.IsEmpty then
    Text := THelperServer.FormatarNumeroBigInt(StrToInt64(Sender.AsString));
end;

procedure TFViewData_Base_LogsEdit.Data_Base_LogsDatasetlog_gfixGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := Sender.AsString.ToUpper;
end;

procedure TFViewData_Base_LogsEdit.Data_Base_LogsDatasetlog_sweepGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := Sender.AsString.ToUpper;
end;

procedure TFViewData_Base_LogsEdit.Data_Base_LogsDatasetstatusGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := Sender.AsString.ToUpper;
end;

procedure TFViewData_Base_LogsEdit.Data_Base_LogsDatasettransacao_finalGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  if not Sender.AsString.IsEmpty then
    Text := THelperServer.FormatarNumeroBigInt(StrToInt64(Sender.AsString));
end;

procedure TFViewData_Base_LogsEdit.Data_Base_LogsDatasettransacao_inicialGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  if not Sender.AsString.IsEmpty then
    Text := THelperServer.FormatarNumeroBigInt(StrToInt64(Sender.AsString));
end;

procedure TFViewData_Base_LogsEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewData_Base_LogsEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.data_base_logs.form.lbid');
  lbstatus := TLabel.Create('view.data_base_logs.form.lbstatus');
  lbtransacao_inicial := TLabel.Create('view.data_base_logs.form.lbtransacao_inicial');
  lbtransacao_final := TLabel.Create('view.data_base_logs.form.lbtransacao_final');
  lbdata_coleta_log := TLabel.Create('view.data_base_logs.form.lbdata_coleta_log');
  lbsweep_executado := TLabel.Create('view.data_base_logs.form.lbsweep_executado');
  lbtempo_gasto_sweep := TLabel.Create('view.data_base_logs.form.lbtempo_gasto_sweep');
  lbdescricao := TLabel.Create('view.data_base_logs.form.lbdescricao');
  lblog_gfix := TLabel.Create('view.data_base_logs.form.lblog_gfix');
  lblog_sweep := TLabel.Create('view.data_base_logs.form.lblog_sweep');
  lbcodigo_interno := TLabel.Create('view.data_base_logs.form.lbcodigo_interno');
  lbinclusao := TLabel.Create('view.data_base_logs.form.lbinclusao');
  lbalteracao := TLabel.Create('view.data_base_logs.form.lbalteracao');
  lbaliado := TLabel.Create('view.data_base_logs.form.lbaliado');
  lbcnpj := TLabel.Create('view.data_base_logs.form.lbcnpj');
  lbdb_path := TLabel.Create('view.data_base_logs.form.lbdb_path');
  lbdiferenca_transacao := TLabel.Create('view.data_base_logs.form.lbdiferenca_transacao');
  btCancel := TButton.Create('view.data_base_logs.form.btBack');
  edid := TDBEdit.Create('view.data_base_logs.form.edid');
  edstatus := TDBEdit.Create('view.data_base_logs.form.edstatus');
  edtransacao_inicial := TDBEdit.Create('view.data_base_logs.form.edtransacao_inicial');
  edtransacao_final := TDBEdit.Create('view.data_base_logs.form.edtransacao_final');
  eddata_coleta_log := TDBEdit.Create('view.data_base_logs.form.eddata_coleta_log');
  edtempo_gasto_sweep := TDBEdit.Create('view.data_base_logs.form.edtempo_gasto_sweep');
  eddescricao := TDBEdit.Create('view.data_base_logs.form.eddescricao');
  edlog_gfix := TDBEdit.Create('view.data_base_logs.form.edlog_gfix');
  edlog_sweep := TDBEdit.Create('view.data_base_logs.form.edlog_sweep');
  edcodigo_interno := TDBEdit.Create('view.data_base_logs.form.edcodigo_interno');
  edinclusao := TDBEdit.Create('view.data_base_logs.form.edinclusao');
  edalteracao := TDBEdit.Create('view.data_base_logs.form.edalteracao');
  edaliado := TDBEdit.Create('view.data_base_logs.form.edaliado');
  edcnpj := TDBEdit.Create('view.data_base_logs.form.edcnpj');
  eddb_path := TDBEdit.Create('view.data_base_logs.form.eddb_path');
  eddiferenca_transacao := TDBEdit.Create('view.data_base_logs.form.eddiferenca_transacao');
  cbxsweep_executado := TDBCheckBox.Create('view.data_base_logs.form.cbxsweep_executado');
  DataSource := TDataSource.Create(Self);
  Data_Base_LogsDataset := TXDataWebDataSet.Create(Self);
  Data_Base_LogsDatasetid := TIntegerField.Create(Self);
  Data_Base_LogsDatasetaliado_id := TIntegerField.Create(Self);
  Data_Base_LogsDatasetdata_base_id := TIntegerField.Create(Self);
  Data_Base_LogsDatasetstatus := TStringField.Create(Self);
  Data_Base_LogsDatasettransacao_inicial := TStringField.Create(Self);
  Data_Base_LogsDatasettransacao_final := TStringField.Create(Self);
  Data_Base_LogsDatasetdata_coleta_log := TDateTimeField.Create(Self);
  Data_Base_LogsDatasetdata_coleta_gfix := TDateTimeField.Create(Self);
  Data_Base_LogsDatasetsweep_executado := TBooleanField.Create(Self);
  Data_Base_LogsDatasettempo_gasto_sweep := TStringField.Create(Self);
  Data_Base_LogsDatasetdescricao := TStringField.Create(Self);
  Data_Base_LogsDatasetlog_gfix := TStringField.Create(Self);
  Data_Base_LogsDatasetlog_sweep := TStringField.Create(Self);
  Data_Base_LogsDatasetcodigo_interno := TIntegerField.Create(Self);
  Data_Base_LogsDatasetinclusao := TDateTimeField.Create(Self);
  Data_Base_LogsDatasetalteracao := TDateTimeField.Create(Self);
  Data_Base_LogsDatasetdb := TXDataWebEntityField.Create(Self);
  Data_Base_LogsDatasetdbaliadoNome_Fantasia := TStringField.Create(Self);
  Data_Base_LogsDatasetdbaliadoCNPJ := TStringField.Create(Self);
  Data_Base_LogsDatasetdbpath := TStringField.Create(Self);
  Data_Base_LogsDatasetdiferenca_transacao := TLargeintField.Create(Self);
  XDataClientData_Base_LogsGet := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbstatus.BeforeLoadDFMValues;
  lbtransacao_inicial.BeforeLoadDFMValues;
  lbtransacao_final.BeforeLoadDFMValues;
  lbdata_coleta_log.BeforeLoadDFMValues;
  lbsweep_executado.BeforeLoadDFMValues;
  lbtempo_gasto_sweep.BeforeLoadDFMValues;
  lbdescricao.BeforeLoadDFMValues;
  lblog_gfix.BeforeLoadDFMValues;
  lblog_sweep.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbaliado.BeforeLoadDFMValues;
  lbcnpj.BeforeLoadDFMValues;
  lbdb_path.BeforeLoadDFMValues;
  lbdiferenca_transacao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edstatus.BeforeLoadDFMValues;
  edtransacao_inicial.BeforeLoadDFMValues;
  edtransacao_final.BeforeLoadDFMValues;
  eddata_coleta_log.BeforeLoadDFMValues;
  edtempo_gasto_sweep.BeforeLoadDFMValues;
  eddescricao.BeforeLoadDFMValues;
  edlog_gfix.BeforeLoadDFMValues;
  edlog_sweep.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edaliado.BeforeLoadDFMValues;
  edcnpj.BeforeLoadDFMValues;
  eddb_path.BeforeLoadDFMValues;
  eddiferenca_transacao.BeforeLoadDFMValues;
  cbxsweep_executado.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Data_Base_LogsDataset.BeforeLoadDFMValues;
  Data_Base_LogsDatasetid.BeforeLoadDFMValues;
  Data_Base_LogsDatasetaliado_id.BeforeLoadDFMValues;
  Data_Base_LogsDatasetdata_base_id.BeforeLoadDFMValues;
  Data_Base_LogsDatasetstatus.BeforeLoadDFMValues;
  Data_Base_LogsDatasettransacao_inicial.BeforeLoadDFMValues;
  Data_Base_LogsDatasettransacao_final.BeforeLoadDFMValues;
  Data_Base_LogsDatasetdata_coleta_log.BeforeLoadDFMValues;
  Data_Base_LogsDatasetdata_coleta_gfix.BeforeLoadDFMValues;
  Data_Base_LogsDatasetsweep_executado.BeforeLoadDFMValues;
  Data_Base_LogsDatasettempo_gasto_sweep.BeforeLoadDFMValues;
  Data_Base_LogsDatasetdescricao.BeforeLoadDFMValues;
  Data_Base_LogsDatasetlog_gfix.BeforeLoadDFMValues;
  Data_Base_LogsDatasetlog_sweep.BeforeLoadDFMValues;
  Data_Base_LogsDatasetcodigo_interno.BeforeLoadDFMValues;
  Data_Base_LogsDatasetinclusao.BeforeLoadDFMValues;
  Data_Base_LogsDatasetalteracao.BeforeLoadDFMValues;
  Data_Base_LogsDatasetdb.BeforeLoadDFMValues;
  Data_Base_LogsDatasetdbaliadoNome_Fantasia.BeforeLoadDFMValues;
  Data_Base_LogsDatasetdbaliadoCNPJ.BeforeLoadDFMValues;
  Data_Base_LogsDatasetdbpath.BeforeLoadDFMValues;
  Data_Base_LogsDatasetdiferenca_transacao.BeforeLoadDFMValues;
  XDataClientData_Base_LogsGet.BeforeLoadDFMValues;
  try
    Name := 'FViewData_Base_LogsEdit';
    Width := 593;
    Height := 511;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 8;
    lbid.Width := 52;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd. Serv:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbstatus.SetParentComponent(Self);
    lbstatus.Name := 'lbstatus';
    lbstatus.Left := 8;
    lbstatus.Top := 34;
    lbstatus.Width := 35;
    lbstatus.Height := 13;
    lbstatus.Caption := 'Status:';
    lbstatus.HeightPercent := 100.000000000000000000;
    lbstatus.WidthPercent := 100.000000000000000000;
    lbtransacao_inicial.SetParentComponent(Self);
    lbtransacao_inicial.Name := 'lbtransacao_inicial';
    lbtransacao_inicial.Left := 8;
    lbtransacao_inicial.Top := 61;
    lbtransacao_inicial.Width := 84;
    lbtransacao_inicial.Height := 13;
    lbtransacao_inicial.Caption := 'Transa'#231#227'o Inicial:';
    lbtransacao_inicial.HeightPercent := 100.000000000000000000;
    lbtransacao_inicial.WidthPercent := 100.000000000000000000;
    lbtransacao_final.SetParentComponent(Self);
    lbtransacao_final.Name := 'lbtransacao_final';
    lbtransacao_final.Left := 8;
    lbtransacao_final.Top := 88;
    lbtransacao_final.Width := 79;
    lbtransacao_final.Height := 13;
    lbtransacao_final.Caption := 'Transa'#231#227'o Final:';
    lbtransacao_final.HeightPercent := 100.000000000000000000;
    lbtransacao_final.WidthPercent := 100.000000000000000000;
    lbdata_coleta_log.SetParentComponent(Self);
    lbdata_coleta_log.Name := 'lbdata_coleta_log';
    lbdata_coleta_log.Left := 8;
    lbdata_coleta_log.Top := 115;
    lbdata_coleta_log.Width := 55;
    lbdata_coleta_log.Height := 13;
    lbdata_coleta_log.Caption := 'Coleta Log:';
    lbdata_coleta_log.HeightPercent := 100.000000000000000000;
    lbdata_coleta_log.WidthPercent := 100.000000000000000000;
    lbsweep_executado.SetParentComponent(Self);
    lbsweep_executado.Name := 'lbsweep_executado';
    lbsweep_executado.Left := 8;
    lbsweep_executado.Top := 145;
    lbsweep_executado.Width := 93;
    lbsweep_executado.Height := 13;
    lbsweep_executado.Caption := 'SWEEP Executado?';
    lbsweep_executado.HeightPercent := 100.000000000000000000;
    lbsweep_executado.WidthPercent := 100.000000000000000000;
    lbtempo_gasto_sweep.SetParentComponent(Self);
    lbtempo_gasto_sweep.Name := 'lbtempo_gasto_sweep';
    lbtempo_gasto_sweep.Left := 8;
    lbtempo_gasto_sweep.Top := 172;
    lbtempo_gasto_sweep.Width := 73;
    lbtempo_gasto_sweep.Height := 13;
    lbtempo_gasto_sweep.Caption := 'Tempo SWEEP:';
    lbtempo_gasto_sweep.HeightPercent := 100.000000000000000000;
    lbtempo_gasto_sweep.WidthPercent := 100.000000000000000000;
    lbdescricao.SetParentComponent(Self);
    lbdescricao.Name := 'lbdescricao';
    lbdescricao.Left := 256;
    lbdescricao.Top := 8;
    lbdescricao.Width := 50;
    lbdescricao.Height := 13;
    lbdescricao.Caption := 'Descri'#231#227'o:';
    lbdescricao.HeightPercent := 100.000000000000000000;
    lbdescricao.WidthPercent := 100.000000000000000000;
    lblog_gfix.SetParentComponent(Self);
    lblog_gfix.Name := 'lblog_gfix';
    lblog_gfix.Left := 256;
    lblog_gfix.Top := 35;
    lblog_gfix.Width := 47;
    lblog_gfix.Height := 13;
    lblog_gfix.Caption := 'Log GFIX:';
    lblog_gfix.HeightPercent := 100.000000000000000000;
    lblog_gfix.WidthPercent := 100.000000000000000000;
    lblog_sweep.SetParentComponent(Self);
    lblog_sweep.Name := 'lblog_sweep';
    lblog_sweep.Left := 256;
    lblog_sweep.Top := 62;
    lblog_sweep.Width := 58;
    lblog_sweep.Height := 13;
    lblog_sweep.Caption := 'Log SWEEP:';
    lblog_sweep.HeightPercent := 100.000000000000000000;
    lblog_sweep.WidthPercent := 100.000000000000000000;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 256;
    lbcodigo_interno.Top := 89;
    lbcodigo_interno.Width := 51;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'C'#243'd. Ret.:';
    lbcodigo_interno.HeightPercent := 100.000000000000000000;
    lbcodigo_interno.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 256;
    lbinclusao.Top := 116;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 256;
    lbalteracao.Top := 143;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbaliado.SetParentComponent(Self);
    lbaliado.Name := 'lbaliado';
    lbaliado.Left := 256;
    lbaliado.Top := 169;
    lbaliado.Width := 33;
    lbaliado.Height := 13;
    lbaliado.Caption := 'Aliado:';
    lbaliado.HeightPercent := 100.000000000000000000;
    lbaliado.WidthPercent := 100.000000000000000000;
    lbcnpj.SetParentComponent(Self);
    lbcnpj.Name := 'lbcnpj';
    lbcnpj.Left := 256;
    lbcnpj.Top := 196;
    lbcnpj.Width := 29;
    lbcnpj.Height := 13;
    lbcnpj.Caption := 'CNPJ:';
    lbcnpj.HeightPercent := 100.000000000000000000;
    lbcnpj.WidthPercent := 100.000000000000000000;
    lbdb_path.SetParentComponent(Self);
    lbdb_path.Name := 'lbdb_path';
    lbdb_path.Left := 8;
    lbdb_path.Top := 199;
    lbdb_path.Width := 61;
    lbdb_path.Height := 13;
    lbdb_path.Caption := 'Caminho DB:';
    lbdb_path.HeightPercent := 100.000000000000000000;
    lbdb_path.WidthPercent := 100.000000000000000000;
    lbdiferenca_transacao.SetParentComponent(Self);
    lbdiferenca_transacao.Name := 'lbdiferenca_transacao';
    lbdiferenca_transacao.Left := 256;
    lbdiferenca_transacao.Top := 223;
    lbdiferenca_transacao.Width := 103;
    lbdiferenca_transacao.Height := 13;
    lbdiferenca_transacao.Caption := 'Diferen'#231'a Transa'#231#227'o:';
    lbdiferenca_transacao.HeightPercent := 100.000000000000000000;
    lbdiferenca_transacao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 8;
    btCancel.Top := 264;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 117;
    edid.Top := 5;
    edid.Width := 120;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edstatus.SetParentComponent(Self);
    edstatus.Name := 'edstatus';
    edstatus.Left := 117;
    edstatus.Top := 31;
    edstatus.Width := 120;
    edstatus.Height := 21;
    edstatus.Enabled := False;
    edstatus.HeightPercent := 100.000000000000000000;
    edstatus.TabOrder := 9;
    edstatus.Text := 'edstatus';
    edstatus.WidthPercent := 100.000000000000000000;
    edstatus.DataField := 'status';
    edstatus.DataSource := DataSource;
    edtransacao_inicial.SetParentComponent(Self);
    edtransacao_inicial.Name := 'edtransacao_inicial';
    edtransacao_inicial.Left := 117;
    edtransacao_inicial.Top := 58;
    edtransacao_inicial.Width := 120;
    edtransacao_inicial.Height := 21;
    edtransacao_inicial.Enabled := False;
    edtransacao_inicial.HeightPercent := 100.000000000000000000;
    edtransacao_inicial.TabOrder := 10;
    edtransacao_inicial.Text := 'edtransacao_inicial';
    edtransacao_inicial.WidthPercent := 100.000000000000000000;
    edtransacao_inicial.DataField := 'transacao_inicial';
    edtransacao_inicial.DataSource := DataSource;
    edtransacao_final.SetParentComponent(Self);
    edtransacao_final.Name := 'edtransacao_final';
    edtransacao_final.Left := 117;
    edtransacao_final.Top := 85;
    edtransacao_final.Width := 120;
    edtransacao_final.Height := 21;
    edtransacao_final.Enabled := False;
    edtransacao_final.HeightPercent := 100.000000000000000000;
    edtransacao_final.TabOrder := 11;
    edtransacao_final.Text := 'edtransacao_final';
    edtransacao_final.WidthPercent := 100.000000000000000000;
    edtransacao_final.DataField := 'transacao_final';
    edtransacao_final.DataSource := DataSource;
    eddata_coleta_log.SetParentComponent(Self);
    eddata_coleta_log.Name := 'eddata_coleta_log';
    eddata_coleta_log.Left := 117;
    eddata_coleta_log.Top := 112;
    eddata_coleta_log.Width := 120;
    eddata_coleta_log.Height := 21;
    eddata_coleta_log.Enabled := False;
    eddata_coleta_log.HeightPercent := 100.000000000000000000;
    eddata_coleta_log.TabOrder := 12;
    eddata_coleta_log.Text := 'eddata_coleta_log';
    eddata_coleta_log.WidthPercent := 100.000000000000000000;
    eddata_coleta_log.DataField := 'data_coleta_log';
    eddata_coleta_log.DataSource := DataSource;
    edtempo_gasto_sweep.SetParentComponent(Self);
    edtempo_gasto_sweep.Name := 'edtempo_gasto_sweep';
    edtempo_gasto_sweep.Left := 117;
    edtempo_gasto_sweep.Top := 169;
    edtempo_gasto_sweep.Width := 120;
    edtempo_gasto_sweep.Height := 21;
    edtempo_gasto_sweep.Enabled := False;
    edtempo_gasto_sweep.HeightPercent := 100.000000000000000000;
    edtempo_gasto_sweep.TabOrder := 15;
    edtempo_gasto_sweep.Text := 'edtempo_gasto_sweep';
    edtempo_gasto_sweep.WidthPercent := 100.000000000000000000;
    edtempo_gasto_sweep.DataField := 'tempo_gasto_sweep';
    edtempo_gasto_sweep.DataSource := DataSource;
    eddescricao.SetParentComponent(Self);
    eddescricao.Name := 'eddescricao';
    eddescricao.Left := 349;
    eddescricao.Top := 5;
    eddescricao.Width := 120;
    eddescricao.Height := 21;
    eddescricao.Enabled := False;
    eddescricao.HeightPercent := 100.000000000000000000;
    eddescricao.TabOrder := 16;
    eddescricao.Text := 'eddescricao';
    eddescricao.WidthPercent := 100.000000000000000000;
    eddescricao.DataField := 'descricao';
    eddescricao.DataSource := DataSource;
    edlog_gfix.SetParentComponent(Self);
    edlog_gfix.Name := 'edlog_gfix';
    edlog_gfix.Left := 349;
    edlog_gfix.Top := 32;
    edlog_gfix.Width := 120;
    edlog_gfix.Height := 21;
    edlog_gfix.Enabled := False;
    edlog_gfix.HeightPercent := 100.000000000000000000;
    edlog_gfix.TabOrder := 17;
    edlog_gfix.Text := 'edlog_gfix';
    edlog_gfix.WidthPercent := 100.000000000000000000;
    edlog_gfix.DataField := 'log_gfix';
    edlog_gfix.DataSource := DataSource;
    edlog_sweep.SetParentComponent(Self);
    edlog_sweep.Name := 'edlog_sweep';
    edlog_sweep.Left := 349;
    edlog_sweep.Top := 59;
    edlog_sweep.Width := 120;
    edlog_sweep.Height := 21;
    edlog_sweep.Enabled := False;
    edlog_sweep.HeightPercent := 100.000000000000000000;
    edlog_sweep.TabOrder := 18;
    edlog_sweep.Text := 'edlog_sweep';
    edlog_sweep.WidthPercent := 100.000000000000000000;
    edlog_sweep.DataField := 'log_sweep';
    edlog_sweep.DataSource := DataSource;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 349;
    edcodigo_interno.Top := 86;
    edcodigo_interno.Width := 120;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := False;
    edcodigo_interno.HeightPercent := 100.000000000000000000;
    edcodigo_interno.TabOrder := 19;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.WidthPercent := 100.000000000000000000;
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 349;
    edinclusao.Top := 113;
    edinclusao.Width := 120;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 20;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 349;
    edalteracao.Top := 140;
    edalteracao.Width := 120;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 21;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edaliado.SetParentComponent(Self);
    edaliado.Name := 'edaliado';
    edaliado.Left := 349;
    edaliado.Top := 166;
    edaliado.Width := 120;
    edaliado.Height := 21;
    edaliado.ChildOrder := 30;
    edaliado.Enabled := False;
    edaliado.HeightPercent := 100.000000000000000000;
    edaliado.TabOrder := 21;
    edaliado.Text := 'edaliado';
    edaliado.WidthPercent := 100.000000000000000000;
    edaliado.DataField := 'db.aliado.Nome_Fantasia';
    edaliado.DataSource := DataSource;
    edcnpj.SetParentComponent(Self);
    edcnpj.Name := 'edcnpj';
    edcnpj.Left := 349;
    edcnpj.Top := 193;
    edcnpj.Width := 120;
    edcnpj.Height := 21;
    edcnpj.ChildOrder := 32;
    edcnpj.Enabled := False;
    edcnpj.HeightPercent := 100.000000000000000000;
    edcnpj.TabOrder := 21;
    edcnpj.Text := 'edcnpj';
    edcnpj.WidthPercent := 100.000000000000000000;
    edcnpj.DataField := 'db.aliado.CNPJ';
    edcnpj.DataSource := DataSource;
    eddb_path.SetParentComponent(Self);
    eddb_path.Name := 'eddb_path';
    eddb_path.Left := 117;
    eddb_path.Top := 196;
    eddb_path.Width := 120;
    eddb_path.Height := 21;
    eddb_path.ChildOrder := 32;
    eddb_path.Enabled := False;
    eddb_path.HeightPercent := 100.000000000000000000;
    eddb_path.TabOrder := 21;
    eddb_path.Text := 'eddb_path';
    eddb_path.WidthPercent := 100.000000000000000000;
    eddb_path.DataField := 'db.path';
    eddb_path.DataSource := DataSource;
    eddiferenca_transacao.SetParentComponent(Self);
    eddiferenca_transacao.Name := 'eddiferenca_transacao';
    eddiferenca_transacao.Left := 349;
    eddiferenca_transacao.Top := 220;
    eddiferenca_transacao.Width := 120;
    eddiferenca_transacao.Height := 21;
    eddiferenca_transacao.ChildOrder := 32;
    eddiferenca_transacao.Enabled := False;
    eddiferenca_transacao.HeightPercent := 100.000000000000000000;
    eddiferenca_transacao.TabOrder := 21;
    eddiferenca_transacao.Text := 'eddiferenca_transacao';
    eddiferenca_transacao.WidthPercent := 100.000000000000000000;
    eddiferenca_transacao.DataField := 'diferenca_transacao';
    eddiferenca_transacao.DataSource := DataSource;
    cbxsweep_executado.SetParentComponent(Self);
    cbxsweep_executado.Name := 'cbxsweep_executado';
    cbxsweep_executado.Left := 117;
    cbxsweep_executado.Top := 141;
    cbxsweep_executado.Width := 120;
    cbxsweep_executado.Height := 22;
    cbxsweep_executado.Caption := 'cbxsweep_executado';
    cbxsweep_executado.ChildOrder := 33;
    cbxsweep_executado.Enabled := False;
    cbxsweep_executado.HeightPercent := 100.000000000000000000;
    cbxsweep_executado.WidthPercent := 100.000000000000000000;
    cbxsweep_executado.DataField := 'sweep_executado';
    cbxsweep_executado.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Data_Base_LogsDataset;
    DataSource.Left := 376;
    DataSource.Top := 264;
    Data_Base_LogsDataset.SetParentComponent(Self);
    Data_Base_LogsDataset.Name := 'Data_Base_LogsDataset';
    Data_Base_LogsDataset.AfterApplyUpdates := Data_Base_LogsDatasetAfterApplyUpdates;
    Data_Base_LogsDataset.EntitySetName := 'Data_Base_Logs';
    Data_Base_LogsDataset.Connection := DMConnection.ApiConnection;
    Data_Base_LogsDataset.Left := 272;
    Data_Base_LogsDataset.Top := 264;
    Data_Base_LogsDatasetid.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetid.Name := 'Data_Base_LogsDatasetid';
    Data_Base_LogsDatasetid.FieldName := 'id';
    Data_Base_LogsDatasetid.Required := True;
    Data_Base_LogsDatasetaliado_id.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetaliado_id.Name := 'Data_Base_LogsDatasetaliado_id';
    Data_Base_LogsDatasetaliado_id.FieldName := 'aliado_id';
    Data_Base_LogsDatasetaliado_id.Required := True;
    Data_Base_LogsDatasetdata_base_id.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetdata_base_id.Name := 'Data_Base_LogsDatasetdata_base_id';
    Data_Base_LogsDatasetdata_base_id.FieldName := 'data_base_id';
    Data_Base_LogsDatasetdata_base_id.Required := True;
    Data_Base_LogsDatasetstatus.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetstatus.Name := 'Data_Base_LogsDatasetstatus';
    Data_Base_LogsDatasetstatus.FieldName := 'status';
    SetEvent(Data_Base_LogsDatasetstatus, Self, 'OnGetText', 'Data_Base_LogsDatasetstatusGetText');
    Data_Base_LogsDatasetstatus.Size := 255;
    Data_Base_LogsDatasettransacao_inicial.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasettransacao_inicial.Name := 'Data_Base_LogsDatasettransacao_inicial';
    Data_Base_LogsDatasettransacao_inicial.FieldName := 'transacao_inicial';
    SetEvent(Data_Base_LogsDatasettransacao_inicial, Self, 'OnGetText', 'Data_Base_LogsDatasettransacao_inicialGetText');
    Data_Base_LogsDatasettransacao_inicial.Size := 255;
    Data_Base_LogsDatasettransacao_final.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasettransacao_final.Name := 'Data_Base_LogsDatasettransacao_final';
    Data_Base_LogsDatasettransacao_final.FieldName := 'transacao_final';
    SetEvent(Data_Base_LogsDatasettransacao_final, Self, 'OnGetText', 'Data_Base_LogsDatasettransacao_finalGetText');
    Data_Base_LogsDatasettransacao_final.Size := 255;
    Data_Base_LogsDatasetdata_coleta_log.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetdata_coleta_log.Name := 'Data_Base_LogsDatasetdata_coleta_log';
    Data_Base_LogsDatasetdata_coleta_log.FieldName := 'data_coleta_log';
    Data_Base_LogsDatasetdata_coleta_log.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Data_Base_LogsDatasetdata_coleta_gfix.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetdata_coleta_gfix.Name := 'Data_Base_LogsDatasetdata_coleta_gfix';
    Data_Base_LogsDatasetdata_coleta_gfix.FieldName := 'data_coleta_gfix';
    Data_Base_LogsDatasetdata_coleta_gfix.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Data_Base_LogsDatasetsweep_executado.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetsweep_executado.Name := 'Data_Base_LogsDatasetsweep_executado';
    Data_Base_LogsDatasetsweep_executado.FieldName := 'sweep_executado';
    Data_Base_LogsDatasettempo_gasto_sweep.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasettempo_gasto_sweep.Name := 'Data_Base_LogsDatasettempo_gasto_sweep';
    Data_Base_LogsDatasettempo_gasto_sweep.FieldName := 'tempo_gasto_sweep';
    Data_Base_LogsDatasettempo_gasto_sweep.Size := 255;
    Data_Base_LogsDatasetdescricao.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetdescricao.Name := 'Data_Base_LogsDatasetdescricao';
    Data_Base_LogsDatasetdescricao.FieldName := 'descricao';
    SetEvent(Data_Base_LogsDatasetdescricao, Self, 'OnGetText', 'Data_Base_LogsDatasetdescricaoGetText');
    Data_Base_LogsDatasetdescricao.Size := 255;
    Data_Base_LogsDatasetlog_gfix.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetlog_gfix.Name := 'Data_Base_LogsDatasetlog_gfix';
    Data_Base_LogsDatasetlog_gfix.FieldName := 'log_gfix';
    SetEvent(Data_Base_LogsDatasetlog_gfix, Self, 'OnGetText', 'Data_Base_LogsDatasetlog_gfixGetText');
    Data_Base_LogsDatasetlog_gfix.Size := 65536;
    Data_Base_LogsDatasetlog_sweep.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetlog_sweep.Name := 'Data_Base_LogsDatasetlog_sweep';
    Data_Base_LogsDatasetlog_sweep.FieldName := 'log_sweep';
    SetEvent(Data_Base_LogsDatasetlog_sweep, Self, 'OnGetText', 'Data_Base_LogsDatasetlog_sweepGetText');
    Data_Base_LogsDatasetlog_sweep.Size := 65536;
    Data_Base_LogsDatasetcodigo_interno.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetcodigo_interno.Name := 'Data_Base_LogsDatasetcodigo_interno';
    Data_Base_LogsDatasetcodigo_interno.FieldName := 'codigo_interno';
    Data_Base_LogsDatasetcodigo_interno.Required := True;
    Data_Base_LogsDatasetinclusao.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetinclusao.Name := 'Data_Base_LogsDatasetinclusao';
    Data_Base_LogsDatasetinclusao.FieldName := 'inclusao';
    Data_Base_LogsDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Data_Base_LogsDatasetalteracao.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetalteracao.Name := 'Data_Base_LogsDatasetalteracao';
    Data_Base_LogsDatasetalteracao.FieldName := 'alteracao';
    Data_Base_LogsDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Data_Base_LogsDatasetdb.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetdb.Name := 'Data_Base_LogsDatasetdb';
    Data_Base_LogsDatasetdb.FieldName := 'db';
    Data_Base_LogsDatasetdbaliadoNome_Fantasia.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetdbaliadoNome_Fantasia.Name := 'Data_Base_LogsDatasetdbaliadoNome_Fantasia';
    Data_Base_LogsDatasetdbaliadoNome_Fantasia.FieldName := 'db.aliado.Nome_Fantasia';
    Data_Base_LogsDatasetdbaliadoCNPJ.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetdbaliadoCNPJ.Name := 'Data_Base_LogsDatasetdbaliadoCNPJ';
    Data_Base_LogsDatasetdbaliadoCNPJ.FieldName := 'db.aliado.CNPJ';
    SetEvent(Data_Base_LogsDatasetdbaliadoCNPJ, Self, 'OnGetText', 'Data_Base_LogsDatasetdbaliadoCNPJGetText');
    Data_Base_LogsDatasetdbpath.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetdbpath.Name := 'Data_Base_LogsDatasetdbpath';
    Data_Base_LogsDatasetdbpath.FieldName := 'db.path';
    Data_Base_LogsDatasetdiferenca_transacao.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetdiferenca_transacao.Name := 'Data_Base_LogsDatasetdiferenca_transacao';
    Data_Base_LogsDatasetdiferenca_transacao.FieldName := 'diferenca_transacao';
    SetEvent(Data_Base_LogsDatasetdiferenca_transacao, Self, 'OnGetText', 'Data_Base_LogsDatasetdiferenca_transacaoGetText');
    XDataClientData_Base_LogsGet.SetParentComponent(Self);
    XDataClientData_Base_LogsGet.Name := 'XDataClientData_Base_LogsGet';
    XDataClientData_Base_LogsGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientData_Base_LogsGet, Self, 'OnLoad', 'XDataClientData_Base_LogsGetLoad');
    XDataClientData_Base_LogsGet.Left := 144;
    XDataClientData_Base_LogsGet.Top := 264;
  finally
    lbid.AfterLoadDFMValues;
    lbstatus.AfterLoadDFMValues;
    lbtransacao_inicial.AfterLoadDFMValues;
    lbtransacao_final.AfterLoadDFMValues;
    lbdata_coleta_log.AfterLoadDFMValues;
    lbsweep_executado.AfterLoadDFMValues;
    lbtempo_gasto_sweep.AfterLoadDFMValues;
    lbdescricao.AfterLoadDFMValues;
    lblog_gfix.AfterLoadDFMValues;
    lblog_sweep.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbaliado.AfterLoadDFMValues;
    lbcnpj.AfterLoadDFMValues;
    lbdb_path.AfterLoadDFMValues;
    lbdiferenca_transacao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edstatus.AfterLoadDFMValues;
    edtransacao_inicial.AfterLoadDFMValues;
    edtransacao_final.AfterLoadDFMValues;
    eddata_coleta_log.AfterLoadDFMValues;
    edtempo_gasto_sweep.AfterLoadDFMValues;
    eddescricao.AfterLoadDFMValues;
    edlog_gfix.AfterLoadDFMValues;
    edlog_sweep.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edaliado.AfterLoadDFMValues;
    edcnpj.AfterLoadDFMValues;
    eddb_path.AfterLoadDFMValues;
    eddiferenca_transacao.AfterLoadDFMValues;
    cbxsweep_executado.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Data_Base_LogsDataset.AfterLoadDFMValues;
    Data_Base_LogsDatasetid.AfterLoadDFMValues;
    Data_Base_LogsDatasetaliado_id.AfterLoadDFMValues;
    Data_Base_LogsDatasetdata_base_id.AfterLoadDFMValues;
    Data_Base_LogsDatasetstatus.AfterLoadDFMValues;
    Data_Base_LogsDatasettransacao_inicial.AfterLoadDFMValues;
    Data_Base_LogsDatasettransacao_final.AfterLoadDFMValues;
    Data_Base_LogsDatasetdata_coleta_log.AfterLoadDFMValues;
    Data_Base_LogsDatasetdata_coleta_gfix.AfterLoadDFMValues;
    Data_Base_LogsDatasetsweep_executado.AfterLoadDFMValues;
    Data_Base_LogsDatasettempo_gasto_sweep.AfterLoadDFMValues;
    Data_Base_LogsDatasetdescricao.AfterLoadDFMValues;
    Data_Base_LogsDatasetlog_gfix.AfterLoadDFMValues;
    Data_Base_LogsDatasetlog_sweep.AfterLoadDFMValues;
    Data_Base_LogsDatasetcodigo_interno.AfterLoadDFMValues;
    Data_Base_LogsDatasetinclusao.AfterLoadDFMValues;
    Data_Base_LogsDatasetalteracao.AfterLoadDFMValues;
    Data_Base_LogsDatasetdb.AfterLoadDFMValues;
    Data_Base_LogsDatasetdbaliadoNome_Fantasia.AfterLoadDFMValues;
    Data_Base_LogsDatasetdbaliadoCNPJ.AfterLoadDFMValues;
    Data_Base_LogsDatasetdbpath.AfterLoadDFMValues;
    Data_Base_LogsDatasetdiferenca_transacao.AfterLoadDFMValues;
    XDataClientData_Base_LogsGet.AfterLoadDFMValues;
  end;
end;

end.
